export default {
  crashcash: {
    development: {
      baseURL: 'https://games-crash-cash-ticket.staging.de-2.nsoft.cloud',
      historyURL: 'https://games-crash-cash-event.staging.de-2.nsoft.cloud',
      lastTicketsURL: 'https://games-read-api.staging.de-2.nsoft.cloud',
      upcomingEvents: '/upcoming/',
      gameResults: '/results/game/',
      ticketBarcodeCheck: '/tickets/barcode/',
      ticketRequestIdCheck: '/tickets/',
      ticketHistory: '/tickets',
      webSocketUrl: 'https://crash-cash-websocket.staging.de-2.nsoft.cloud',
    },
    staging: {
      baseURL: 'https://games-aggregator.staging.de-2.nsoft.cloud',
      historyURL: 'https://games-crash-cash-event.staging.de-2.nsoft.cloud',
      lastTicketsURL: 'https://games-read-api.staging.de-2.nsoft.cloud',
      upcomingEvents: '/upcoming/',
      gameResults: '/results/game/',
      ticketBarcodeCheck: '/seven/tickets/barcode',
      ticketRequestIdCheck: '/seven/tickets',
      ticketHistory: '/tickets',
      webSocketUrl: 'https://crash-cash-websocket.staging.de-2.nsoft.cloud',
    },
    production: {
      baseURL: 'https://games-aggregator.de-2.nsoft.cloud',
      historyURL: 'https://games-crash-cash-event.de-2.nsoft.cloud',
      lastTicketsURL: 'https://games-read-api.de-2.nsoft.cloud',
      upcomingEvents: '/upcoming/',
      gameResults: '/results/game/',
      ticketBarcodeCheck: '/seven/tickets/barcode',
      ticketRequestIdCheck: '/seven/tickets',
      ticketHistory: '/tickets',
      webSocketUrl: 'https://crash-cash-websocket.de-2.nsoft.cloud',
    },
  },
  ngsMonolith: {
    development: {
      baseURL: 'https://menhir.staging.gb.nsoftcdn.com/shop',
      ngsURL: 'https://games.staging.gb.nsoftcdn.com/app.php',
      lastTicketsURL: 'https://games-read-api.staging.de-2.nsoft.cloud',
      gameResults: '/api_open/retail/events.json',
      ticketBarcodeCheck: '/tickets/check/',
      ngsTicketBarcodeCheck: '/api_open/retail/tickets/',
      ticketRequestIdCheck: '/tickets/request/',
      ticketHistory: '/tickets',
      paytable: '/api_open/keno/paytable',
      ngsTicketRequestIdCheck: '/api_open/retail/tickets/request/',
    },
    staging: {
      baseURL: 'https://menhir.staging.gb.nsoftcdn.com/shop',
      ngsURL: 'https://games.staging.gb.nsoftcdn.com/app.php',
      lastTicketsURL: 'https://games-read-api.staging.de-2.nsoft.cloud',
      gameResults: '/api_open/retail/events.json',
      ticketBarcodeCheck: '/tickets/check/',
      ngsTicketBarcodeCheck: '/api_open/retail/tickets/',
      ticketRequestIdCheck: '/tickets/request/',
      ticketHistory: '/tickets',
      paytable: '/api_open/keno/paytable',
      ngsTicketRequestIdCheck: '/api_open/retail/tickets/request/',
    },
    production: {
      baseURL: 'https://menhir.gb.nsoftcdn.com/shop',
      baseURL_DE: 'https://menhir.de.nsoftcdn.com/shop',
      baseURL_RO2: 'https://menhir.ro-2.nsoftcdn.com/shop',
      baseURL_RO: 'https://menhir.ro.nsoftcdn.com/shop',
      baseURL_RS2: 'https://menhir.rs-2.nsoftcdn.com/shop',
      baseURL_RS: 'https://menhir.rs.nsoftcdn.com/shop',
      ngsURL: 'https://games.gb.nsoftcdn.com/app.php',
      ngsURL_DE: 'https://games.de.nsoftcdn.com/app.php',
      ngsURL_RO2: 'https://games.ro.nsoftcdn.com/app.php',
      ngsURL_RO: 'https://games.ro.nsoftcdn.com/app.php',
      ngsURL_RS2: 'https://games.gb.nsoftcdn.com/app.php',
      ngsURL_RS: 'https://games.gb.nsoftcdn.com/app.php',
      lastTicketsURL: 'https://games-read-api.de-2.nsoft.cloud',
      gameResults: '/api_open/retail/events.json',
      ticketBarcodeCheck: '/tickets/check/',
      ngsTicketBarcodeCheck: '/api_open/retail/tickets/',
      ticketRequestIdCheck: '/tickets/request/',
      ticketHistory: '/tickets',
      paytable: '/api_open/keno/paytable',
      ngsTicketRequestIdCheck: '/api_open/retail/tickets/request/',
    },
  },
  common: {
    development: {
      static_NETLIFY: 'https://dev.games-static.7platform.net',
      static_CF: 'https://dev.games-static.nsoft.app',
      companyConfig: '/company-config',
    },
    staging: {
      static_NETLIFY: 'https://dev.games-static.7platform.net',
      static_CF: 'https://dev.games-static.nsoft.app',
      companyConfig: '/company-config',
    },
    production: {
      static_NETLIFY: 'https://games-static.7platform.net',
      static_CF: 'https://games-static.nsoft.app',
      companyConfig: '/company-config',
    },
  },
};
